import React, { useEffect, useState } from "react";
import axios from "axios";
import DomainAssignPopup   from "./DomainAssignPopup";
import { BASE_URL } from "../services/configUrls";

function DomainAssignPopupHandler() {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    checkPopupStatus();
  }, []);

  const checkPopupStatus = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/institute/domain-approval-popup-status`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );

      if (res.data.status === "open") {
        setOpen(true);
      }
    } catch (error) {
      console.error("Popup status check failed", error);
    } finally {
      setChecked(true);
    }
  };

  const handleClose = async () => {
    try {
      await axios.post(
        `${BASE_URL}/institute/domain-approval-popup-status`,
        {}, // 👈 empty body
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      setOpen(false);
    } catch (error) {
      console.error("Popup close failed", error);
    }
  };

  if (!checked) return null;

  return (
    <DomainAssignPopup
      open={open}
      onClose={handleClose}
    />
  );
}

export default DomainAssignPopupHandler;
